import AsyncStorage from "@react-native-async-storage/async-storage";
import type { ReceiptDraft } from "./shipmentReceiptUtils";

const keyFor = (ticketId: number, shipmentId: number) => `ticketing.receiptDraft.${ticketId}.${shipmentId}`;

/** A dock connection can drop mid-count, so the partial count is kept on the device until it is confirmed. */
export const loadReceiptDraft = async (ticketId: number, shipmentId: number): Promise<Partial<ReceiptDraft> | null> => {
  try {
    const raw = await AsyncStorage.getItem(keyFor(ticketId, shipmentId));
    return raw ? (JSON.parse(raw) as Partial<ReceiptDraft>) : null;
  } catch {
    return null;
  }
};

export const saveReceiptDraft = async (ticketId: number, shipmentId: number, draft: ReceiptDraft): Promise<void> => {
  try {
    await AsyncStorage.setItem(keyFor(ticketId, shipmentId), JSON.stringify(draft));
  } catch {
    // Storage is best effort; the in-memory draft still survives a failed request.
  }
};

export const clearReceiptDraft = async (ticketId: number, shipmentId: number): Promise<void> => {
  try {
    await AsyncStorage.removeItem(keyFor(ticketId, shipmentId));
  } catch {
    // Nothing to clean up if storage is unavailable.
  }
};
